import React from "react";
import { ItineraryItem, Location } from "@/types";

interface TravelItemProps {
  travelDay: ItineraryItem;
  previousLocation: Location;
  selectedLocation: Location;
}

const TravelItem: React.FC<TravelItemProps> = ({
  travelDay,
  previousLocation,
  selectedLocation,
}) => {
  return (
    <div className="bg-neutral-100/70 rounded-lg py-3 px-4 w-full">
      <div className="flex flex-row items-center justify-between">
        <div className="flex flex-row items-center space-x-4">
          {/* Add image here */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-tickets-plane w-5 h-5 text-neutral-600"
          >
            <path d="M10.5 17h1.227a2 2 0 0 0 1.345-.52L18 12" />
            <path d="m12 13.5 3.75.5" />
            <path d="m4.5 8 10.58-5.06a1 1 0 0 1 1.342.488L18.5 8" />
            <path d="M6 10V8" />
            <path d="M6 14v1" />
            <path d="M6 19v2" />
            <rect x="2" y="8" width="20" height="13" rx="2" />
          </svg>
          <div className="flex flex-col items-start">
            <p className="text-sm text-neutral-700 font-medium mb-0.5">
              {travelDay.name}
            </p>
            <p className="text-xs text-neutral-500 font-light">
              In transit from {previousLocation.name} to {selectedLocation.name}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TravelItem;
